export function colorToHex(color) {
    return "#" + color.r.toString(16).padStart(2, "0") + color.g.toString(16).padStart(2, "0") + color.b.toString(16).padStart(2, "0")
}

export function hexToColor(hex) {
    if (hex.length === 7) {
        hex = hex.substr(1)
    }
    return {
        r: parseInt(hex.substr(0, 2), 16),
        g: parseInt(hex.substr(2, 2), 16),
        b: parseInt(hex.substr(4, 2), 16),
    };
}
